<script lang="ts" setup>
export interface Card {
    card_title: string
    card_cta: string
    card_image: string
    card_in_new_window: string
}

export interface PagebuilderCardsGrandProps {
    data: {
        cards: Card[]
    }
}

const props = defineProps<PagebuilderCardsGrandProps>()
</script>

<template>
  <LazyScrollSection class="mb-5 mb-md-20 g-6 pb-10 pb-md-0">
    <ScrollSectionItem
      v-for="(card, cardIndex) in props.data.cards"
      :key="`card-${cardIndex}`"
      class="col-10 col-md-6 col-lg-3"
    >
      <article
        class="cards-grand-item rounded px-5 py-8 px-md-9 py-md-12 box-shadow-1 h-100 position-relative transition"
        :class="{ 'has-cta': card.card_cta }"
      >
        <a
          v-if="card.card_cta"
          :href="card.card_cta"
          :target="card.card_in_new_window === '1' ? '_blank' : '_self'"
          class="stretched-link"
          :aria-label="card.card_title"
        />
        <img
          :src="card.card_image"
          width="48"
          height="48"
          loading="lazy"
          decoding="async"
          alt=""
          class="d-block mx-auto mb-6"
        >
        <h3 class="text-center fs-normal">
          {{ card.card_title }}
        </h3>

        <svg
          v-if="card.card_in_new_window === '1'"
          class="d-block flex-shrink-0 position-absolute cards-grand-item__external-icon"
          width="16"
          height="16"
        >
          <use xlink:href="#external" />
          <title>{{ $t('Odkaz sa otvára v novom okne') }}</title>
        </svg>
      </article>
    </ScrollSectionItem>
  </lazyscrollsection>
</template>

<style scoped lang="scss">
@import './PagebuilderCardsGrand.scss';
</style>